import { makeStyles } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import clsx from 'clsx';

import { ContentCell } from './ContentCell';

interface MinMaxCellProps {
  min: string | number | null | undefined;
  max: string | number | null | undefined;
  avg: string | number | null | undefined;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  arrow: {
    fontSize: 8,
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  value: {
    fontSize: 12,
    color: grey[600],
    textAlign: 'right',
    flex: 1,
    fontWeight: 400,
  },
  centerText: {
    fontWeight: 'bold',
    fontSize: 14,
    textAlign: 'right',
    flex: 1,
  },
  centerIcon: {
    fontWeight: 'bold',
    fontSize: 13,
    color: theme.palette.common.black,
    flexShrink: 0,
  },
}));

export const MinMaxCell = ({ min, max, avg }: MinMaxCellProps): JSX.Element => {
  const classes = useStyles();

  return (
    <ContentCell className={classes.root}>
      <div className={classes.row}>
        <span className={classes.arrow}>▲</span>
        <span className={classes.value}>{min ?? '-'}</span>
      </div>
      <div className={classes.row}>
        <span className={clsx(classes.centerIcon, classes.arrow)}>&empty;</span>
        <span className={classes.centerText}>{avg ?? '-'}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.arrow}>▼</span>
        <span className={classes.value}>{max ?? '-'}</span>
      </div>
    </ContentCell>
  );
};
